
<template>
  <div class="itmform-container">
      <ValidationObserver class="needs-validation form-custom-format " v-bind:class="{'was-validated' : validated}" tag="form" ref="observer" v-slot="{passes}" @submit.prevent="onSubmitForm()">
        <XWindow ref="window" title="BULK UPDATE" windowClass="height-auto" scrollClass='import-invoice-form height-auto' :height="600" :width="1024" :formStatus="formStatus" @dialog-state="dialogState" :group="(group + 10)">
              <template #left-button>

                    <template v-if="postCounter < dataLength">
                        <button class="btn btn-sm btn-elegant" :disabled="true"><span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            Loading...</button>
                    </template>
                    <template v-else>
                        <mdb-btn color="elegant" size="sm" @click="passes(onSubmitForm())" :disabled="processing">UPDATE</mdb-btn>
                      </template>

                      <mdb-btn color="elegant" size="sm" @click="clearForm" :disabled="(postCounter < dataLength)">CLEAR</mdb-btn>

              </template>
            <div class="p-0 m-0 w-100">
              <div ref="spreadsheet"></div>
            </div>
        </XWindow>
      </ValidationObserver>

  </div>
</template>
<script>
/* eslint-disable no-unused-vars */
/* eslint-disable vue/no-unused-components */
/* eslint-disable no-prototype-builtins */

import { mdbBtn,mdbContainer, mdbRow,mdbCol, mdbIcon, mdbCard, mdbTabs, mdbTab, mdbTabItem, mdbTabContent, mdbTabPane, mdbDropdown,mdbDropdownToggle,mdbDropdownMenu,mdbDropdownItem,} from "mdbvue";
import { ValidationObserver } from "vee-validate";
import { mapActions,mapGetters, mapMutations } from 'vuex'


import { MessageBox } from 'element-ui';
import XWindow from '../../components/thats/XWindow.vue'
import jspreadsheet from '../../jsexcel/jexcel'
export default {
  props : {
    group : {
      type : Number,
      default : 2
    },
    update : {
      type : String,
      default : 'update'
    }
  },

    components: {

        mdbContainer,
        mdbBtn,
        mdbRow,
        mdbCol,  
        mdbIcon,
        mdbCard,
        mdbTabs,
        mdbTab,
        mdbTabItem,
        mdbTabContent,
        mdbTabPane,
        mdbDropdown,mdbDropdownToggle,mdbDropdownMenu,mdbDropdownItem,
        ValidationObserver,
  
        XWindow
  },
    
    data(){


      return {
      postCounter : 0,
      dataLength : 0,
      validated : false,
      processing : false,
      formStatus : 'create',
      spreadsheet: null,
      exportTableOptions : {
            download : false,
            allowDeleteColumn : false,
            allowRenameColumn : false,
            defaultColAlign : 'left',
            csvHeader:true,
            tableWidth : '100%',
            tableHeight : 'auto',
            tableOverflow : true,
             data:[[]],
             minDimensions:[3,20],
             onCopy : null,
             selectionCopy : false,
             allowCopy : true,
             columns: [],

             contextMenu: function(obj, x, y, e) {

                return false;
             }
        },
    }

    },

    created : function() {
     
    },
    updated(){
      this.toggleCheck()
    },


    methods: {
      ...mapActions('InventoryItemMasterModule',['bulkItemUpdate']),

      formResetter(){

      },

      onSubmitForm(){
        const self = this;
        if(this.processing === false){
            const tableData = this.spreadsheet.getJson();


            MessageBox.confirm('Are you sure you want to update?', 'Warning', {
                  confirmButtonText: 'OK',
                  cancelButtonText: 'Cancel',
                  type: 'warning'
                  }).then(() => {
                    if(tableData.length > 0){
              
                        this.postCounter = 0
                        const filterStatus = [];
                        this.dataLength = tableData.filter((item) => item.series !== '' && !filterStatus.includes(item.message),[]).length;

                        if(this.dataLength > 0){

                          self.processing = true
                              tableData.forEach((element, forIndex) => {
                                    const row = 1 + forIndex
                                    console.log("tableData" + row)
                                    if(element.series !== '' && !filterStatus.includes(element.message)){
                                      self.processing = true;


                                      //const columnAlpha = self.numberToAlphabetic(row);
                                      


                                      // console.log(element)

                                      const fields = {series : element.series, index : row};

                                      if(element.hasOwnProperty('status')){
                                        fields.status = element.status
                                      }

                                      if(element.hasOwnProperty('weblive_status')){
                                        fields.website = element.weblive_status
                                      }

                                      if(element.hasOwnProperty('sale_price')){
                                        fields.sale_price = element.sale_price
                                      }

                                      if(element.hasOwnProperty('percent_discount')){
                                        fields.percent_discount = element.percent_discount
                                      }

                                      if(element.hasOwnProperty('discount')){
                                        fields.discount = element.discount
                                      }


                                      

                                      // self.spreadsheet.setValue(`D${row}`,'Loading...');
                                    
                                      this.bulkItemUpdate(fields).then((response) => {
                
                                                const i = parseInt(response.index);
                
                                                self.spreadsheet.setStyle(`A${i}`,'background-color','#00c851');
                                                self.spreadsheet.setStyle(`B${i}`,'background-color','#00c851');
                                                self.spreadsheet.setStyle(`C${i}`,'background-color','#00c851');
                                                self.spreadsheet.setStyle(`D${i}`,'background-color','#00c851');
                                                self.spreadsheet.setStyle(`E${i}`,'background-color','#00c851');
                                                self.spreadsheet.setValue(`D${i}`,'Success...');
                                                self.spreadsheet.setValue(`E${i}`,response.message);
                                                self.processing = false
                                                this.postCounter++
                                              }).catch((error) => {
                                                

                                                console.log(error)
                                                  const i = parseInt(error.response.data.index)
                                                  self.spreadsheet.setValue(`D${i}`,'Failed...');
                                                  self.spreadsheet.setValue(`E${i}`,error.response.data.message);
                                                  self.spreadsheet.setStyle(`A${i}`,'background-color','#fb3');
                                                  self.spreadsheet.setStyle(`B${i}`,'background-color','#fb3');
                                                  self.spreadsheet.setStyle(`C${i}`,'background-color','#fb3');
                                                  self.spreadsheet.setStyle(`D${i}`,'background-color','#fb3');
                                                  self.spreadsheet.setStyle(`E${i}`,'background-color','#fb3');
                                                  self.processing = false
                                                  this.postCounter++
                
                                              });
                                            }
                                          
                                  });
                        


                                }

                          
                        }
                  })


       
            






               /*  const filterData = tableData.filter(function(rowElement){
                    return rowElement.series != "";
                })

                if(filterData.length > 0){
                    console.log(filterData)
                } */
            
        }
      },

      openDialog(){
        this.$refs.window.openDialog();
      },

      createPopupTable(exportTableOptions){
        const columns = [
                
                {
                    type: 'text',
                    width: '200px',
                    title: 'Item Code',
                    name: 'series',
                    readOnly: false,
                    primaryKey: false,
                    showIn: ['default'],
                },
                {
                    type: 'dropdown',
                    width: '180px',
                    title:'Status',
                    name:'status',
                    autocomplete:true,
                    source:[
                        {name : "Archive", id : "Archive"},
                            {name : "Active", id : "Active"},
                            {name : "Discontinued", id : "Discontinued"},
                    ],
                    multiple:false,
                    showIn: ['status'],
                },
                {
                    type: 'dropdown',
                    width: '180px',
                    title:'Weblive Status',
                    name:'weblive_status',
                    autocomplete:true,
                    source:[
                    {name : "Yes", id : "Yes"},
                    {name : "No", id : "No"},
                  ],
                    multiple:false,
                    showIn: ['status'],
                },
                {
                   

                   type: 'numeric',
                   title:'Price',
                   mask:'#,##.00',
                   width:100,
                   decimal:'.',
                   name:'sale_price',
                   showIn: ['price'],
               },
               {
                   

                   type: 'numeric',
                   title:'%',
                   mask:'0',
                   width:100,
                   decimal:'.',
                   name:'percent_discount',
                   showIn: ['price'],
               },
               {
                   

                   type: 'numeric',
                   title:'Discount',
                   mask:'#,##.00',
                   width:100,
                   decimal:'.',
                   name:'discount',
                   showIn: ['price'],
               },
                {
                    type: 'text',
                    width: '200px',
                    title: 'Progress',
                    name: 'progress',
                    showIn: ['default'],
                },
                {
                    type: 'text',
                    width: '340px',
                    title: 'Response',
                    name: 'message',
                    showIn: ['default'],
                },
                
              
            ];
            let filteredColumns = columns;
            if(this.update == 'price'){
              const filterArray = ['default','price'];
              filteredColumns = columns.filter(item => item.showIn.some(attr => filterArray.includes(attr)));
            }


            if(this.update == 'status'){
              const filterArray = ['default','status'];
              filteredColumns = columns.filter(item => item.showIn.some(attr => filterArray.includes(attr)));
              }


              

              exportTableOptions.columns = filteredColumns;

            this.spreadsheet = jspreadsheet(this.$refs.spreadsheet, exportTableOptions);
            Object.assign(this, this.spreadsheet);
            this.spreadsheet.setWidth(window.innerWidth)
            this.spreadsheet.setData([])
        },

        async recreateSpreadsheet(){
            await this.spreadsheet.destroy();
        },

        dialogState(state){
        this.active = 0;

        if(!state){
          this.formResetter();
          this.spreadsheet.destroy();
          return
        }

        if(this.formStatus == 'create'){
          this.formResetter();
          this.createPopupTable(this.exportTableOptions)   
        }

        this.processing = false
        
      },

      clearForm(){
          this.recreateSpreadsheet();
          this.createPopupTable(this.exportTableOptions);
      },

      printLabel(obj = false,logo = false){

        const tableData = this.spreadsheet.getJson();
        const tableContent = tableData.filter((item) => item.series !== '',[]).map(item => item.series);


        var strWindowFeatures = "location=yes,height=600,width=900,scrollbars=yes,status=yes";

        const win = window.open(`/barcode/multiple-print?items=${tableContent}&redirection=${obj}&from=bulk&logo=${logo}`, "_blank", strWindowFeatures);
            win.document.title = 'Print';
            win.print()
      },
        printLabelDiscount(obj = false,logo = false){

          const tableData = this.spreadsheet.getJson();
        const tableContent = tableData.filter((item) => item.series !== '',[]).map(item => item.series);
        var strWindowFeatures = "location=yes,height=600,width=900,scrollbars=yes,status=yes";

        const win = window.open(`/barcode/multiple-print-discount?items=${tableContent}&redirection=${obj}&from=bulk&logo=${logo}`, "_blank", strWindowFeatures);
            win.document.title = 'Print';
            win.print()
      },
        printLabelSmallDiscount(obj = false,logo = false){

          const tableData = this.spreadsheet.getJson();
        const tableContent = tableData.filter((item) => item.series !== '',[]).map(item => item.series);

        var strWindowFeatures = "location=yes,height=600,width=900,scrollbars=yes,status=yes";

        const win = window.open(`/barcode/multiple-print-small-discount?items=${tableContent}&redirection=${obj}&from=bulk&logo=${logo}`, "_blank", strWindowFeatures);
            win.document.title = 'Print';
            win.print()
      },
        printLabelSmall(obj = false,logo = false){

          const tableData = this.spreadsheet.getJson();
        const tableContent = tableData.filter((item) => item.series !== '',[]).map(item => item.series);
        var strWindowFeatures = "location=yes,height=600,width=900,scrollbars=yes,status=yes";

        const win = window.open(`/barcode/multiple-print-small?items=${tableContent}&redirection=${obj}&from=bulk&logo=${logo}`, "_blank", strWindowFeatures);
            win.document.title = 'Print';
            win.print()
      },

      numberToAlphabetic(num) {
        let result = '';
        while (num > 0) {
          const remainder = (num - 1) % 26;
          result = String.fromCharCode('a'.charCodeAt(0) + remainder) + result;
          num = Math.floor((num - 1) / 26);
        }
        return result;
      }

    },

    computed: {

      
    },

    watch : {

        dialogIsOpen : function(v){
            if(v === false){
  
                this.spreadsheet.destroy();
            }else{
                this.createPopupTable(this.exportTableOptions)                 
            }

            
        }

        
    }


}
</script>
<style lang="scss" scoped>

</style>